import LayerManager from './layerManager';
import "./layermanager.less";

export default LayerManager;
